/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cv_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid color (e.g. #6366f1, rgb(99, 102, 241) or hsl(239, 84%, 67%)).`)
};

const es_cv_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa un color válido (p. ej. #6366f1, rgb(99, 102, 241) o hsl(239, 84%, 67%)).`)
};

const de_cv_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine gültige Farbe ein (z. B. #6366f1, rgb(99, 102, 241) oder hsl(239, 84%, 67%)).`)
};

const nl_cv_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een geldige kleur in (bijv. #6366f1, rgb(99, 102, 241) of hsl(239, 84%, 67%)).`)
};

const fr_cv_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez une couleur valide (par ex. #6366f1, rgb(99, 102, 241) ou hsl(239, 84%, 67%)).`)
};

const it_cv_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un colore valido (ad es. #6366f1, rgb(99, 102, 241) o hsl(239, 84%, 67%)).`)
};

const pt_br2_cv_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite uma cor válida (ex: #6366f1, rgb(99, 102, 241) ou hsl(239, 84%, 67%)).`)
};

const pt_cv_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza uma cor válida (por ex. #6366f1, rgb(99, 102, 241) ou hsl(239, 84%, 67%)).`)
};

const ja_cv_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効な色を入力してください（例：#6366f1、rgb(99, 102, 241)、またはhsl(239, 84%, 67%)）。`)
};

const zh_cv_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入有效的颜色（例如 #6366f1、rgb(99, 102, 241) 或 hsl(239, 84%, 67%)）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cv_invalid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cv_invalid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cv_invalid", locale)
	if (locale === "en") return en_cv_invalid(inputs)
	if (locale === "es") return es_cv_invalid(inputs)
	if (locale === "de") return de_cv_invalid(inputs)
	if (locale === "nl") return nl_cv_invalid(inputs)
	if (locale === "fr") return fr_cv_invalid(inputs)
	if (locale === "it") return it_cv_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_cv_invalid(inputs)
	if (locale === "pt") return pt_cv_invalid(inputs)
	if (locale === "ja") return ja_cv_invalid(inputs)
	return zh_cv_invalid(inputs)
};